// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PCQV1","title":"styles_title__lZ7s-"};